import * as React from "react";
import {Component} from "react";
import {Icon} from "bloomer";
import styled from "react-emotion";
import RatingWindow from "./RatingWindow";
import Stars from "./Stars";
import "./style.css";
import {addModelReview, getModelInfo} from "../../../api/models/ModelInfo";
import BeautifyDecimal from "../../../utils/BeautifyDecimal";

const EmptyContainer = styled("div")`
    vertical-align: middle;
    display: inline-block;
    height: 30px;
    margin: -5px 10px 0 10px;
    border-left: 1px solid #c4c4c4;
`;

const RatingContainer = styled("div")`
    vertical-align: middle;
    display: inline-block;
    margin-top: -5px;
`;

const LatencyUptimeContainer  = styled("div")`
    vertical-align: middle;
    display: inline-block;
    padding-right: 5px;
    text-align: right;
    font-size: 14px;
`;

const WindowTicker = styled("span")`
    cursor: pointer;
    font-size: 14px;
    font-weight: normal;
    
    :hover {
        color: black;
    }
`;

interface IModelInfoProps {
    model: string;
}

interface IModelInfoState {
    loading: boolean;
    model: string;
    average: number;
    totalReviews: number;
    userScore: number;
    latency: string;
    uptime: string;
    showWindow: boolean;
}

class ModelInfo extends Component<IModelInfoProps, IModelInfoState> {

    public constructor(props: IModelInfoProps) {
        super(props);

        this.state = {
            loading: false,
            model: props.model,
            average: 0,
            totalReviews: 0,
            userScore: 0,
            latency: "",
            uptime: "",
            showWindow: false
        };
    }

    public componentDidMount() {
        this.loadModelInfo(true);
    }

    public async loadModelInfo(showLoading: boolean) {
        if (showLoading) {
            this.setState({loading: true});
        }

        const data: any = await getModelInfo(this.state.model);
        if (data) {
            const {score, latency, uptime} = data;
            this.setState({
                loading: false,
                average: score.average,
                totalReviews: score.total,
                userScore: score.user_score,
                latency: this.beautifyLatencyValue(latency),
                uptime: Math.floor(uptime) + "%"
            });
        }
    }

    public async saveModelReview(score: number) {
        const response = await addModelReview(this.state.model, score);
        this.loadModelInfo(false);
        return response;
    }

    public beautifyLatencyValue(value: number) {
        let text = "";
        if (value < 1000) {
            text = value + " ms";
        } else if (value < 60000) {
            text = BeautifyDecimal(value / 1000, 1) + " sec";
        } else if (value < 3600000) {
            text = Math.floor(value / 60000) + "min";
            if (Math.floor(value/1000) % 60 > 0) {
                text += " " + (Math.floor(value / 1000) % 60) + "sec";
            }
        } else {
            text = "N/A";
        }
        return text;
    }

    public render() {
        if (this.state.loading) {
            return <React.Fragment>
                <EmptyContainer/>
                <RatingContainer>
                    <Icon className="fas fa-spinner fa-spin"/>
                </RatingContainer>
            </React.Fragment>;
        }

        return <React.Fragment>
            <EmptyContainer/>
            <RatingContainer>
            <span style={{
                fontSize: '16px',
                fontWeight: 'bold',
                margin: '0px 5px'
            }}>
                {this.state.average.toFixed(1)}
            </span>
                <Stars isFixed={true} value={this.state.average}/>
                <span style={{
                    fontSize: '14px',
                    fontWeight: 'normal',
                    margin: '0px 5px',
                    color: 'grey'
                }}>
                <div
                    style={{
                        display: 'inline-block',
                        position: 'relative'
                    }}
                    onMouseOver={() => {
                        this.setState({
                            showWindow: true
                        });
                    }}
                >
                    <WindowTicker>
                        <Icon className="fas fa-angle-down"/>
                    </WindowTicker>
                    {
                        this.state.showWindow ? <RatingWindow
                            onBlur={() => {
                                this.setState({
                                    showWindow: false
                                });
                            }}
                            average={this.state.average}
                            totalReviews={this.state.totalReviews}
                            userScore={this.state.userScore}
                            onReviewSave={(newScore: number) => {
                                return this.saveModelReview(newScore);
                            }}
                        /> : <></>
                    }
                </div>
                <span>
                    {" "}{this.state.totalReviews}
                </span>
            </span>
            </RatingContainer>
            <EmptyContainer/>
            <LatencyUptimeContainer>
                    <div style={{color: 'grey'}}>
                        <Icon className="far fa-clock"/>
                        <span style={{marginLeft: '4px'}}>Latency</span>
                    </div>
                    <b>{this.state.latency}</b>
            </LatencyUptimeContainer>
            <EmptyContainer/>
            <LatencyUptimeContainer>
                <span style={{
                    fontSize: '14px'
                }}>
                    <div style={{color: 'grey'}}>
                        <Icon className="fas fa-check"/>
                        <span style={{marginLeft: '4px'}}>Uptime</span>
                    </div>
                    <b>{this.state.uptime}</b>
                </span>
            </LatencyUptimeContainer>
        </React.Fragment>;
    }
}

export default ModelInfo;


// WEBPACK FOOTER //
// ./src/components/model/ModelInfo/index.tsx